<h2 mat-dialog-title class="dialog-title">Indikator(en) hinzufügen</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmIndicator">
    <div class="form-group">
      <input type="hidden" formControlName="room_id" />
      <input type="hidden" formControlName="standort_id" />
    </div>
    
    <div class="form-group">
      <label class="form-label" for="indikator_id">CODE/SYSTEMTYP *</label>
      <select class="form-control" id="indikator_id" formControlName="indikator_id" required [disabled]="loading" (change)="onIndikatorSelected()">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let indikator of indikatoren" [value]="indikator.id">
          {{ indikator.code }} - {{ indikator.beschreibung }} ({{ indikator.einheit || 'keine Einheit' }})
        </option>
      </select>
      <div *ngIf="loading" class="text-sm text-gray-500 mt-1">Lade Indikatoren...</div>
    </div>
    
    <div class="form-group">
      <label class="form-label" for="name">Position *</label>
      <input type="text" class="form-control" id="name" formControlName="name" placeholder="Position eingeben" required />
    </div>
    
    <div class="form-group">
      <label class="form-label" for="anzahl">Anzahl *</label>
      <input type="number" class="form-control" id="anzahl" formControlName="anzahl" placeholder="Anzahl der zu erstellenden Indikatoren" min="1" max="100" required />
      <small class="text-gray-500">Geben Sie die Anzahl der Indikatoren ein, die erstellt werden sollen (1-100)</small>
    </div>
    
    <div class="form-group">
      <label class="form-label" for="schwellenwert">Schwellenwert *</label>
      <input type="text" class="form-control" id="schwellenwert" formControlName="schwellenwert" placeholder="Schwellenwert" required />
    </div>
    
    <div class="form-group">
      <label class="form-label" for="einheit">Einheit *</label>
      <input type="text" class="form-control" id="einheit" formControlName="einheit" placeholder="Einheit" required />
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Erstellen</button>
</mat-dialog-actions>
